export const NOTE = 'note';
export const RATING = 'rating';
export const ID = 'id';
export const RATING_USER_TYPE = 'ratingUserType';
export const JOB_ID = 'jobId';
export const WORKER_ID = 'workerId';
export const EMPLOYER_ID = 'employerId';